
<header class="sf-header dashboard-header">
  <h1 class="dashboard-header__title">
    {{ 'creator.dashboard.header.greeting' | transloco }}
    @if (user && user.firstname) {
      <span> {{ user.firstname }}</span>
    }
  </h1>

  <div class="dashboard-header__actions">
    <button
      class="button button--primary"
      type="button"
      (click)="openShareProfileModal()"
    >
      <i class="fa-solid fa-arrow-up-right-from-square"></i>
      {{ 'share-banner.cta.label'|transloco }}
    </button>
  </div>
</header>

<app-share-profile-modal
  [open]="isShareProfileModalShown"
  (close)="closeShareProfileModal()"
></app-share-profile-modal>
<app-share-instagram-modal
  [open]="isShareInstagramModalShown"
  [profileLink]="shareProfileUrl"
  (close)="closeShareInstagramModal()"
></app-share-instagram-modal>

<section class="dashboard-stats">
  <div class="sf-section dashboard-stats__stat">
    <p class="dashboard-stats__stat-label">{{ 'creator.dashboard.stats.customers.label' | transloco }}</p>
    @if (statistics && statistics.numberOfCustomers !== null) {
      <p class="dashboard-stats__stat-value">{{statistics.numberOfCustomers}}</p>
    } @else {
      <div class="dashboard-stats__stat-value skeleton-loading"></div>
    }
    @if (statistics && statistics.numberOfCustomersThisMonth !== null) {
      <p class="dashboard-stats__stat-delta">
        {{ 'creator.dashboard.stats.customers.delta' | transloco : { count: statistics.numberOfCustomersThisMonth } }}
      </p>
    }
    @if (statistics === null) {
      <div class="dashboard-stats__stat-delta skeleton-loading"></div>
    }
  </div>
  <div class="sf-section dashboard-stats__stat">
    <p class="dashboard-stats__stat-label">{{ 'creator.dashboard.stats.bookings.label' | transloco }}</p>
    @if (statistics && statistics.numberOfBookings !== null) {
      <p class="dashboard-stats__stat-value">{{statistics.numberOfBookings}}</p>
    } @else {
      <div class="dashboard-stats__stat-value skeleton-loading"></div>
    }
    @if (statistics && statistics.numberOfBookingsThisMonth !== null) {
      <p class="dashboard-stats__stat-delta">
        {{ 'creator.dashboard.stats.bookings.delta' | transloco : { count: statistics.numberOfBookingsThisMonth } }}
      </p>
    }
    @if (statistics === null) {
      <div class="dashboard-stats__stat-delta skeleton-loading"></div>
    }
  </div>
  <div class="sf-section dashboard-stats__stat">
    <p class="dashboard-stats__stat-label">{{ 'creator.dashboard.stats.revenue.label' | transloco }}</p>
    @if (statistics && statistics.totalRevenue !== null && statistics.totalRevenue !== undefined) {
      <p class="dashboard-stats__stat-value">{{statistics.totalRevenue|currency:'EUR'}}</p>
    } @else {
      <div class="dashboard-stats__stat-value skeleton-loading"></div>
    }
    @if (statistics && statistics.totalRevenueThisMonth !== null && statistics.totalRevenueThisMonth !== undefined) {
      <p class="dashboard-stats__stat-delta">
        {{ 'creator.dashboard.stats.revenue.delta' | transloco : { value: (statistics.totalRevenueThisMonth|currency:'EUR') } }}
      </p>
    }
    @if (statistics === null) {
      <div class="dashboard-stats__stat-delta skeleton-loading"></div>
    }
  </div>
</section>

@if (onboarding?.instagramLinkShared === false) {
  <section class="instagram-banner">
    <div class="instagram-banner__content">
      <p class="instagram-banner__eyebrow">{{ 'creator.dashboard.instagram-banner.eyebrow' | transloco }}</p>
      <h3 class="instagram-banner__title">{{ 'creator.dashboard.instagram-banner.title' | transloco }}</h3>
      <p class="instagram-banner__description">{{ 'creator.dashboard.instagram-banner.description' | transloco }}</p>
    </div>

    <button class="button button--primary" type="button" (click)="openShareInstagramModal()">
      <i class="fa-brands fa-instagram"></i>
      {{ 'creator.dashboard.instagram-banner.cta' | transloco }}
    </button>
  </section>
}

<section>
  <app-view-stats
    [stats]="viewStats"
    [loading]="viewStatsLoading"
    [error]="viewStatsError"
  ></app-view-stats>
</section>

<section>
  <app-onboarding-banner
    [photographer]="user"
  ></app-onboarding-banner>
</section>
